// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"c2c35f39","363":"01eaffa2"}[chunkId] + ".chunk.js";
};